import * as React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AbaToastContainer } from '@ReactComponents/AbaToastContainer';
import { ModalRoot } from '@ReactComponents/Shared/ModalRoot';
import { SignUpPage } from '@ReactComponents/SignUp/SignUpPage';
import { SignUpWorkflow } from '@ReactComponents/SignUp/SignUpWorkflow';

import { store } from '@ReactStore/store';

import { AbacusEmbarkProvider } from 'shared/AbacusEmbarkProvider';

import i18n from '../i18n';

const queryClient = new QueryClient();
__webpack_public_path__ = window.webpack_public_path;
ReactDOM.render(
  <AbacusEmbarkProvider>
    <BrowserRouter>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <IntlProvider locale="en-US">
            <QueryClientProvider client={queryClient}>
              <Routes>
                <Route path="/signup" element={<SignUpPage />} />
                <Route path="/signup/onboarding" element={<SignUpWorkflow />} />
                <Route path="/signup/onboarding/cards_completed" element={<SignUpWorkflow startStage={'PAYMENT_SUMMARY'} />} />
                <Route
                  path="/signup/additional_company"
                  element={<SignUpWorkflow startStage={'COMPANY_INFORMATION'} isAdditionalCompany />}
                />
              </Routes>
              <ModalRoot />
            </QueryClientProvider>
          </IntlProvider>
        </I18nextProvider>
        <AbaToastContainer />
      </Provider>
    </BrowserRouter>
  </AbacusEmbarkProvider>,
  document.querySelector('#app')
);
